import React, { useEffect } from "react";
import ListPowerBiScreen from "../screens/ListPowerBiScreen";
import { connect } from "react-redux";
import get from "../../utils/get";
import * as actions from "../actions/list";

const ListPowerBiContainer = (props) => {
  useEffect(() => {
    props.getScreens();
    // eslint-disable-next-line
  }, []);
  return <ListPowerBiScreen {...props} />;
};

const mapStateToProps = (state) => ({
  isLoading: get(state, "test.list.isLoading"),
  reportsData: get(state, "test.list.reportsData"),
});

const mapActionsToProps = { ...actions };

export default connect(
  mapStateToProps,
  mapActionsToProps
)(ListPowerBiContainer);
